export default __webpack_public_path__ + "static/media/FifthAve.1716751a.jpg";